export default __webpack_public_path__ + "static/media/328.bd16825d.jpg";